(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[968],{

/***/ 2433:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationDetailLocationEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organizationLocation_Entry"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uri"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"openingsHours"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"website"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"facebookAccount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"twitterAccount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"handicapAccessible"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"label"},"value":{"kind":"BooleanValue","value":true}}],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"accessibilityFeatures"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"label"},"value":{"kind":"BooleanValue","value":true}}],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"visitAddressHide"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"visitAddress"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lng"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"parts"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"postcode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"number"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"county"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"postalAddressHide"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"postalAddress"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lng"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"parts"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"postcode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"number"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"county"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationDetailEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organization_Entry"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uri"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"organizationCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"hasDescendants"},"value":{"kind":"BooleanValue","value":false}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationDetailLocationEntry"},"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationDetailFacilityEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"facility_Entry"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uri"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}},{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrganizationDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"section"},"value":{"kind":"StringValue","value":"organizations","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"slug"}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationDetailEntry"},"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"facilities"},"name":{"kind":"Name","value":"entries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"section"},"value":{"kind":"StringValue","value":"facilities","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"relatedToEntries"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"slug"}}]}}]}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationDetailFacilityEntry"},"directives":[]}]}}]}}],"loc":{"start":0,"end":1119}};
    doc.loc.source = {"body":"fragment OrganizationDetailLocationEntry on organizationLocation_Entry {\n  id\n  title\n  uri\n  slug\n  phone\n  openingsHours\n  email\n  website\n  facebookAccount\n  twitterAccount\n  handicapAccessible(label: true)\n  accessibilityFeatures(label: true)\n  visitAddressHide\n  visitAddress {\n    lat\n    lng\n    parts {\n      city\n      postcode\n      number\n      address\n      county\n    }\n  }\n  postalAddressHide\n  postalAddress {\n    lat\n    lng\n    parts {\n      city\n      postcode\n      number\n      address\n      county\n    }\n  }\n}\n\nfragment OrganizationDetailEntry on organization_Entry {\n  id\n  title\n  uri\n  description\n  organizationCategory(hasDescendants: false) {\n    id\n    title\n  }\n  locations {\n    ...OrganizationDetailLocationEntry\n  }\n}\n\nfragment OrganizationDetailFacilityEntry on facility_Entry {\n  id\n  title\n  uri\n  description\n}\n\nquery OrganizationDetail($slug: String!) {\n  entry(section: \"organizations\", slug: [$slug]) {\n    ...OrganizationDetailEntry\n  }\n  facilities: entries(\n    section: \"facilities\"\n    relatedToEntries: [{ slug: [$slug] }]\n  ) {\n    ...OrganizationDetailFacilityEntry\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports.OrganizationDetailLocationEntry = oneQuery(doc, "OrganizationDetailLocationEntry");
        
        module.exports.OrganizationDetailEntry = oneQuery(doc, "OrganizationDetailEntry");
        
        module.exports.OrganizationDetailFacilityEntry = oneQuery(doc, "OrganizationDetailFacilityEntry");
        
        module.exports.OrganizationDetail = oneQuery(doc, "OrganizationDetail");
        


/***/ }),

/***/ 2819:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/organisaties/[organization]",
      function () {
        return __webpack_require__(6459);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _wwtr_components_layout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5896);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(5850);
/* harmony import */ var _wwtr_components_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1015);
/* harmony import */ var _wwtr_gql_queries_organization_detail_gql__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2433);
/* harmony import */ var _wwtr_gql_queries_organization_detail_gql__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_wwtr_gql_queries_organization_detail_gql__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _wwtr_libs_apollo_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(730);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3801);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _wwtr_libs_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6614);
/* harmony import */ var react_feather__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9046);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3153);
/* harmony import */ var _wwtr_libs_contexts__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3614);














var LocationData = function(param) {
    var heading = param.heading, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dt", {
                className: "text-sm text-gray-700",
                children: heading
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dd", {
                className: "mb-4",
                children: children
            })
        ]
    });
};
var OrganizationLocation = function(param) {
    var location = param.location;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_wwtr_components_ui__WEBPACK_IMPORTED_MODULE_4__/* .Tile */ .n9, {
        padded: true,
        size: "md",
        variant: "white",
        hasShadow: true,
        className: "flex flex-col sm:flex-row mb-6",
        children: [
            location.visitAddress.lat && location.visitAddressHide === false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figure", {
                className: "mb-4 sm:mb-auto sm:mr-4 md:mr-6 lg:mr-8 flex-shrink-0 overflow-hidden rounded-md",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "https://maps.googleapis.com/maps/api/staticmap?center=".concat(location.visitAddress.lat, ",").concat(location.visitAddress.lng, "&markers=color:0x2a378d|size:mid|").concat(location.visitAddress.lat, ",").concat(location.visitAddress.lng, "&zoom=14&size=575x208&scale=2&maptype=roadmap&key=AIzaSyALAoCzT99hIXU-2VR94P8Bdhz2xp4IWXY"),
                    title: "",
                    className: "sm:w-52 h-52 object-cover"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "col-span-3 space-y-4 sm:space-y-6",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wwtr_components_ui__WEBPACK_IMPORTED_MODULE_4__/* .Heading */ .X6, {
                        level: 3,
                        children: location.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("dl", {
                        children: [
                            location.visitAddress.parts.address && location.visitAddressHide === false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(LocationData, {
                                heading: "Bezoekadres",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("address", {
                                        className: "mb-2",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    location.visitAddress.parts.address,
                                                    " ",
                                                    location.visitAddress.parts.number
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                children: [
                                                    location.visitAddress.parts.postcode,
                                                    " ",
                                                    location.visitAddress.parts.city
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_wwtr_components_ui__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
                                        as: "a",
                                        size: "xs",
                                        color: "powerblue",
                                        appearance: "outline",
                                        target: "_blank",
                                        withIcon: true,
                                        href: "https://maps.google.com/maps?daddr=".concat(encodeURIComponent(location.visitAddress.parts.address.trim() + " " + location.visitAddress.parts.number.trim() + "," + location.visitAddress.parts.city.trim())),
                                        title: "Plan route naar ".concat(location.title, " met Google Maps"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: "Plan route met Google Maps"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_feather__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                className: "inline ml-1 w-4 align-top"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            location.postalAddress.parts.address && location.postalAddressHide === false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LocationData, {
                                heading: "Postadres",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("address", {
                                    className: "mb-2",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            children: [
                                                location.postalAddress.parts.address,
                                                " ",
                                                location.postalAddress.parts.number
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            children: [
                                                location.postalAddress.parts.postcode,
                                                " ",
                                                location.postalAddress.parts.city
                                            ]
                                        })
                                    ]
                                })
                            }),
                            location.phone && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LocationData, {
                                heading: "Telefoonnummer",
                                children: location.phone
                            }),
                            location.email && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LocationData, {
                                heading: "E-mailadres",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wwtr_components_ui__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .rU, {
                                    href: "mailto:".concat(location.email),
                                    title: "Stuur een e-mail naar dit adres",
                                    children: location.email
                                })
                            }),
                            location.website && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LocationData, {
                                heading: "Website",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_wwtr_components_ui__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .rU, {
                                    href: location.website,
                                    target: "_blank",
                                    title: "Open link in een nieuw venster",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: new URL(location.website).host
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_feather__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                            className: "inline ml-1 w-4 align-top"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LocationData, {
                                heading: "Toegankelijk voor gehandicapten",
                                children: location.handicapAccessible
                            }),
                            location.accessibilityFeatures.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LocationData, {
                                heading: "Toegankelijkheid voorzieningen",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                    children: location.accessibilityFeatures.map(function(feature, index) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: feature
                                        }, "location_accessibility_feature_".concat(index));
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var OrganizationFacility = function(param) {
    var facility = param.facility;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_wwtr_components_ui__WEBPACK_IMPORTED_MODULE_4__/* .Tile */ .n9, {
        padded: true,
        size: "md",
        variant: "white",
        hasShadow: true,
        hoverScale: true,
        className: "group flex h-full lg:h-auto flex-col mb-6",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wwtr_components_ui__WEBPACK_IMPORTED_MODULE_4__/* .Heading */ .X6, {
                level: 3,
                className: "mb-4",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                    href: "/".concat(facility.uri),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wwtr_components_ui__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .rU, {
                        href: "/".concat(facility.uri),
                        noWrap: false,
                        title: "Lees meer over ".concat(facility.title),
                        children: facility.title
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-lg mb-4",
                dangerouslySetInnerHTML: {
                    __html: (0,_wwtr_libs_utils__WEBPACK_IMPORTED_MODULE_9__/* .getFirstParagraph */ .PJ)(facility.description, 160)
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex flex-row justify-end group",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                    href: "/".concat(facility.uri),
                    passHref: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_wwtr_components_ui__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
                        as: "a",
                        color: "primary",
                        appearance: "outline",
                        withIcon: true,
                        size: "sm",
                        title: "Lees meer over ".concat(facility.title),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: "Lees meer"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_solid__WEBPACK_IMPORTED_MODULE_10__/* .ArrowRightIcon */ .LZ3, {
                                className: "w-4"
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var OrganizationDetailPage = function() {
    var ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var organization = router.query.organization;
    var ref1 = (0,_wwtr_libs_contexts__WEBPACK_IMPORTED_MODULE_11__/* .useFavorites */ .rc)(), toggleFavorite = ref1.toggleFavorite, favorites = ref1.favorites;
    var onClickFavorite = function($event, id) {
        toggleFavorite(_wwtr_libs_contexts__WEBPACK_IMPORTED_MODULE_11__/* .FAVORITE_TYPE.ORGANIZATION */ .RN.ORGANIZATION, id);
    };
    var ref2 = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_13__/* .useQuery */ .a)((_wwtr_gql_queries_organization_detail_gql__WEBPACK_IMPORTED_MODULE_5___default()), {
        notifyOnNetworkStatusChange: true,
        variables: {
            slug: organization
        },
        skip: !organization
    }), organizationDetailData = ref2.data, organizationDetailNetworkStatus = ref2.networkStatus, organizationDetailError = ref2.error;
    var ref3 = (0,_wwtr_libs_apollo_utils__WEBPACK_IMPORTED_MODULE_6__/* .getNetworkStatusDetails */ .Xr)(organizationDetailNetworkStatus), organizationDetailIsLoading = ref3.isLoading, organizationDetailIsReady = ref3.isReady;
    // if (organizationDetailIsReady && (organizationDetailError || !organizationDetailData?.entry)) {
    //   return <App404 />;
    // }
    var breadCrumbs = [
        {
            url: "/zoek/organisaties",
            label: "Organisaties"
        }, 
    ];
    var entry = organizationDetailData === null || organizationDetailData === void 0 ? void 0 : organizationDetailData.entry;
    var facilities = organizationDetailData === null || organizationDetailData === void 0 ? void 0 : organizationDetailData.facilities;
    var isFavorite = favorites === null || favorites === void 0 ? void 0 : (ref = favorites.organizations) === null || ref === void 0 ? void 0 : ref.includes(entry === null || entry === void 0 ? void 0 : entry.id);
    if (organizationDetailIsReady) {
        // Always push own entry
        breadCrumbs.push({
            label: entry === null || entry === void 0 ? void 0 : entry.title,
            shorten: true
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wwtr_components_layout__WEBPACK_IMPORTED_MODULE_1__/* .Seo */ .pQ, {
                title: entry === null || entry === void 0 ? void 0 : entry.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wwtr_components_ui__WEBPACK_IMPORTED_MODULE_4__/* .PageHeader */ .mr, {
                title: entry === null || entry === void 0 ? void 0 : entry.title,
                isLoading: organizationDetailIsLoading,
                breadCrumbs: breadCrumbs
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wwtr_components_ui__WEBPACK_IMPORTED_MODULE_4__/* .Section */ .$0, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wwtr_components_ui__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W2, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "grid grid-cols-12 gap-6",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "col-span-12 lg:col-span-8 xl:col-span-7",
                                children: [
                                    organizationDetailIsLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "space-y-6 mt-4",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wwtr_components_ui__WEBPACK_IMPORTED_MODULE_4__/* .Skeleton */ .Od, {
                                                className: "w-full h-5 lg:h-6"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wwtr_components_ui__WEBPACK_IMPORTED_MODULE_4__/* .Skeleton */ .Od, {
                                                className: "w-7/12 h-5 lg:h-6"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wwtr_components_ui__WEBPACK_IMPORTED_MODULE_4__/* .Skeleton */ .Od, {
                                                className: "w-9/12 h-5 lg:h-6"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wwtr_components_ui__WEBPACK_IMPORTED_MODULE_4__/* .Skeleton */ .Od, {
                                                className: "w-1/3 h-5 lg:h-6"
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "mb-8 text-2xl leading-snug lg:text-3xl lg:leading-snug text-gray-700",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wwtr_components_ui__WEBPACK_IMPORTED_MODULE_4__/* .RichText */ .Ho, {
                                            content: entry === null || entry === void 0 ? void 0 : entry.description
                                        })
                                    }),
                                    !organizationDetailIsLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "mb-16",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wwtr_components_ui__WEBPACK_IMPORTED_MODULE_4__/* .Heading */ .X6, {
                                                        variant: "gray-800",
                                                        level: 2,
                                                        className: "mb-8",
                                                        isLoading: organizationDetailIsLoading,
                                                        children: "Locaties"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        children: entry === null || entry === void 0 ? void 0 : entry.locations.map(function(location, locationIndex) {
                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(OrganizationLocation, {
                                                                location: location
                                                            }, "location_".concat(locationIndex));
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "mb-16",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wwtr_components_ui__WEBPACK_IMPORTED_MODULE_4__/* .Heading */ .X6, {
                                                        variant: "gray-800",
                                                        level: 2,
                                                        className: "mb-8",
                                                        isLoading: organizationDetailIsLoading,
                                                        children: "Hulpaanbod"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "-mx-4 lg:mx-0",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wwtr_components_ui__WEBPACK_IMPORTED_MODULE_4__/* .Carousel */ .lr, {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                                className: "grid grid-flow-col lg:grid-flow-row lg:grid-cols-1 gap-8 lg:gap-2",
                                                                children: facilities === null || facilities === void 0 ? void 0 : facilities.map(function(facility, facilityIndex) {
                                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                        className: "w-80vw sm:w-60vw md:w-40vw lg:w-auto",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(OrganizationFacility, {
                                                                            facility: facility
                                                                        }, "facility_".concat(facilityIndex))
                                                                    }, "organization_facility_".concat(facilityIndex));
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "hidden lg:block col-span-12 lg:col-span-4 xl:col-start-9 print:hidden",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "sticky top-32",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "mb-8",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_wwtr_components_ui__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
                                            appearance: isFavorite ? "solid" : "outline",
                                            color: "hotpink",
                                            fullWidth: true,
                                            withIcon: true,
                                            className: "mb-4",
                                            onClick: function($event) {
                                                return onClickFavorite($event, entry.id);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_7__/* .HeartIcon */ .h_8, {
                                                    className: "w-6"
                                                }),
                                                isFavorite ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    children: "Verwijder uit favorieten"
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    children: "Opslaan in favorieten"
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wwtr_components_ui__WEBPACK_IMPORTED_MODULE_4__/* .Section */ .$0, {
                as: "aside",
                className: "bg-powerblue print:hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_wwtr_components_ui__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W2, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wwtr_components_ui__WEBPACK_IMPORTED_MODULE_4__/* .Heading */ .X6, {
                            level: 2,
                            variant: "white",
                            className: "mb-12",
                            children: "Niet gevonden wat u zocht?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "inline-flex flex-wrap items-baseline",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-white opacity-80 mb-4 mr-4",
                                    children: "Bekijk meer:"
                                }),
                                entry === null || entry === void 0 ? void 0 : entry.organizationCategory.map(function(category, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "mb-4 mr-4",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                                            href: "/zoek/organisaties/?c=".concat(category.id),
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wwtr_components_ui__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
                                                as: "a",
                                                appearance: "outline",
                                                color: "white",
                                                size: "sm",
                                                title: "Lees meer over ".concat(category.title),
                                                children: category.title
                                            })
                                        })
                                    }, "category".concat(index));
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
// export async function getStaticPaths() {
//   return {
//     paths: [
//       { params: { ... } } // See the "paths" section below
//     ],
//     fallback: true, false, or 'blocking' // See the "fallback" section below
//   };
// }
/* harmony default export */ __webpack_exports__["default"] = (OrganizationDetailPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(2819); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);